import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";
import landleaselogo from "../images/landleaselogo.png";

import AccountCircle from "@mui/icons-material/AccountCircle";
import MoreIcon from "@mui/icons-material/MoreVert";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SettingsIcon from "@mui/icons-material/Settings";
import Toolbar from "@mui/material/Toolbar";
import { logout } from "../features/userSlice";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import SnackbarHandler from "../components/Snackbar";
import Button from "@mui/material/Button";

import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { BiSupport } from "react-icons/bi";

import {
  workspaceSaveDataCall,
  setWorkspaceDataSaveSuccess,
} from "../features/workspaceDataSlice";
import DialogActions from "@mui/material/DialogActions";
import { SessionTimeout } from "../features/SessionTimeout";

const Header = (props) => {
  const {
    savedWorkspaceData,
    netZeroPathwayData,
    workspaceData,
    workspaceDataSaveSuccess,
    workspaceDataSaveError,
    workspaceDataSaveLoading,
    assessmentId,getWorkspaceDataError
  } = useSelector((state) => state.workspaceData);
  const { accessToken, userLoggedIn } = useSelector((state) => state.user);
  const { assessmentDataSuccess } = useSelector((state) => state.assessment);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);
  const name = user != null ? user.name : null;
  const stringAvatar = (name) => {
    return {
      sx: {
        bgcolor: "#23B4C3",
        width: "32px",
        height: "32px",
      },
      children: `${name.toUpperCase().split(" ")[0][0]}${
        name.toUpperCase().split(" ")[1][0]
      }`,
    };
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const [supportAnchorEl, setSupportAnchorEl] = useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isSupportMenuOpen = Boolean(supportAnchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const menuId = "primary-search-account-menu";
  const supportMenuId = "primary-search-support-menu";

  const mobileMenuId = "primary-search-account-menu-mobile";

  const [saveOpen, setSaveOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [logoutClicked, setLogOutClicked] = useState(false);
  const [homepageClicked, setHomePageClicked] = useState(false);
  const [homepageSaveOpen, setHomepageSaveOpen] = useState(false);
  const [homeSaveClicked, setHomeSaveClicked] = useState(false);


  
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleSaveClickOpen = () => {
    setSaveOpen(true);
  };

  const handleSaveClose = () => {
    setSaveOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNoSaveandLogout = () => {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("assessmentId");
    dispatch(logout());
    navigate("/login");
  };
  const handleSave = () => {
    setLogOutClicked(true);
    setSaveOpen(false);
    if (savedWorkspaceData.length > 0) {
      const newData = savedWorkspaceData
        .filter(
          (element) =>
            element.building_sub_elements !== "" && element.quantity > 0
        )
        .map(
          ({ header, id, emission_intensity, subproductExists, ...rest }) => {
            const emissionIntensityValue = parseFloat(emission_intensity);
            return {
              ...rest,
              emission_intensity: emissionIntensityValue,
            };
          }
        );

      const finalData = newData;
      const savedData = [];
      const assessment_id = workspaceData?.assessment_unique_id;
      const savedItems = {
        assessment_id: assessment_id,
        workspace_products: finalData,
        workspace_materials: netZeroPathwayData,
      };

      dispatch(workspaceSaveDataCall({ accessToken, savedItems }));
    }
    if (assessmentDataSuccess && savedWorkspaceData.length === 0) {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("assessmentId");
      dispatch(logout());
      setHomePageClicked(true);
      navigate("/login");
    }
  };
  useEffect(() => {
    if (workspaceDataSaveSuccess && logoutClicked == true) {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("assessmentId");
      dispatch(logout());
      navigate("/login");
    }
  }, [workspaceDataSaveSuccess]);

  const handleHomepageClose = () => {
    setHomepageSaveOpen(false);
  };

  useEffect(() => {
    if (
      workspaceDataSaveSuccess &&
      homeSaveClicked &&
      !workspaceDataSaveLoading
    ) {
      navigate("/home");
    }
  }, [workspaceDataSaveSuccess, workspaceDataSaveLoading]);
  const handleHomepageSave = () => {
    if (savedWorkspaceData.length > 0) {
      setHomeSaveClicked(true);
      setHomepageSaveOpen(false);
      const newData = savedWorkspaceData
        .filter(
          (element) =>
            element.building_sub_elements !== "" && element.quantity > 0
        )
        .map(
          ({ header, id, emission_intensity, subproductExists, ...rest }) => {
            const emissionIntensityValue = parseFloat(emission_intensity);
            return {
              ...rest,
              emission_intensity: emissionIntensityValue,
            };
          }
        );

      const finalData = newData;
      const savedData = [];
      const assessment_id = workspaceData?.assessment_unique_id;
      const savedItems = {
        assessment_id: assessment_id,
        workspace_products: finalData,
        workspace_materials: netZeroPathwayData,
      };

      dispatch(workspaceSaveDataCall({ accessToken, savedItems }));
    }
  };

  const handleHomepageSaveClose = () => {
    navigate("/home");
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSupportMenuOpen = (event) => {
    setSupportAnchorEl(event.currentTarget);
    //setSupportAnchorEl()
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  const handleSupportMenuClose = () => {
    setSupportAnchorEl(null);
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const gotoHomePage = () => {
    setHomepageSaveOpen(true);
  };
  const gotoHomeNoEdit = () => {
    navigate("/home");
  };
  const renderSupportMenu = (
    <Menu
      sx={{ mt: "40px", mr: "40px" }}
      anchorEl={supportAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={supportMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isSupportMenuOpen}
      onClose={handleSupportMenuClose}
    >
      <MenuItem>
        <a
          href="https://lendlease.sharepoint.com/:b:/s/SustainabilityDataStrategyFY23/EUUN-zuHDpVKhGvZyIQS__gBF_T5z2t60653pwKVB5zY4Q?e=wSdqi0"
          target="-"
        >
          User Guide
        </a>
      </MenuItem>
      <MenuItem>
        <a href="https://lendlease.sharepoint.com/:v:/s/SustainabilityDataStrategyFY23/EWtkR_32E5ZHoKPypCBuQiQBByqaNSLvxE5D6DbxZCPIhQ?e=7JmRvp" target="=">
          Video Tutorial
        </a>
      </MenuItem>
      <MenuItem>
        <a
          href="https://urldefense.proofpoint.com/v2/url?u=https-3A__lendlease.service-2Dnow.com_lendlease-3Fid-3Dsc-5Fcat-5Fitem-26sys-5Fid-3D7358349913f06e00c4cbff82e144b08a&d=DwMFAw&c=eIGjsITfXP_y-DLLX0uEHXJvU8nOHrUK8IrwNKOtkVU&r=1njzQesM7F6N40gFajuXkvwRxq8NsPbJk1qbzw_Y1Z0&m=iK4pQdDTCe67ujRXI3aDXOXkJedXUtmAL8suQPA3mr1QqYOjMEihMu9mDqb05g5h&s=eUCbI1wB819a78RQcn1p4xFldid-1UbHppYgtFhY8E0&e="
          target="="
        >
          Report Technical Issue
        </a>
      </MenuItem>
    </Menu>
  );

  const renderMenu = (
    <Menu
      sx={{ mt: "40px" }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleSaveClickOpen}>Save and Logout</MenuItem>
      <MenuItem onClick={handleClickOpen}>Logout without Saving</MenuItem>

      <Dialog
        open={saveOpen}
        onClose={handleSaveClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you really want to Save and Logout
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave}>Yes</Button>
          <Button onClick={handleSaveClose} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you really want to Logout Without Save
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNoSaveandLogout}>Yes</Button>
          <Button onClick={handleClose} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Menu>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <Tooltip title="Targeted For Future Release">
        <MenuItem>
          <IconButton
            size="large"
            aria-label="show 4 new mails"
            color="#808080"
          >
            <SettingsIcon />
          </IconButton>
          <p>Messages</p>
        </MenuItem>
      </Tooltip>
      <Tooltip title="Targeted For Future Release">
        <MenuItem>
          <IconButton
            size="large"
            aria-label="show 17 new notifications"
            color="#808080"
          >
            <Badge badgeContent={17} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <p>Notifications</p>
        </MenuItem>
      </Tooltip>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          {name != null ? (
            <Avatar {...stringAvatar(name)} />
          ) : (
            <AccountCircle />
          )}
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" style={{ backgroundColor: "#012A31" }}>
        <SessionTimeout timeoutMinutes={60} />
        <Toolbar>
          <div
            onClick={
              props.home !== "homepage" &&
              props.workspace == "workspace" &&
              props.edited == true
                ? gotoHomePage
                : gotoHomeNoEdit
            }
            style={{
              paddingRight: "24px",
              borderRight: "solid 1px #8C8C8C",
              display: "flex",
              flexDirection: "row",
              cursor: "pointer",
            }}
          >
            <div>
              <img src={landleaselogo} alt="LendLease Logo" />
            </div>
            <div>
              <Typography
                style={{ color: "#9EE0F6", fontFamily: "RalewayLight" }}
                sx={{
                  fontSize: "1rem",
                  color: "#23B4C3",
                  lineHeight: "1.125rem",
                  align: "left",
                  marginLeft: "1rem",
                }}
              >
                Lendlease
              </Typography>
              <Typography
                style={{ color: "#ffffff", fontFamily: "RalewayMedium" }}
                sx={{
                  fontSize: "1rem",
                  color: "#FFFFFF",
                  align: "left",
                  ml: "1rem",
                  mb: ".5rem",
                }}
              >
                Embodied Carbon Advisor
              </Typography>
            </div>
          </div>
          {props.home !== "homepage" &&
            props.workspace == "workspace" &&
            props.edited == true && (
              <Dialog
                open={homepageSaveOpen}
                onClose={handleHomepageClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Do you want to Save the changes
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleHomepageSave}>Yes</Button>
                  <Button onClick={handleHomepageSaveClose} autoFocus>
                    No
                  </Button>
                </DialogActions>
              </Dialog>
            )}
          <Box sx={{ flexGrow: 1 }} />
          <Box
            sx={{
              paddingLeft: "24px",
              borderLeft: "solid 1px #8C8C8C",
              display: { xs: "none", md: "flex" },
            }}
          >
            <Tooltip title="Targeted For Future Release">
              <IconButton
                size="large"
                aria-label="show 4 new mails"
                style={{ color: "#808080" }}
              >
                <SettingsIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Targeted For Future Release">
              <IconButton
                size="large"
                aria-label="show 17 new notifications"
                style={{ color: "#808080" }}
              >
                <NotificationsIcon />
              </IconButton>
            </Tooltip>
            <IconButton
              size="large"
              edge="end"
              sx={{ mr: "2px" }}
              aria-label="help desk"
              aria-controls={supportMenuId}
              aria-haspopup="true"
              onClick={handleSupportMenuOpen}
              color="inherit"
            >
              <BiSupport />
            </IconButton>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              {name != null ? (
                <Avatar {...stringAvatar(name)} />
              ) : (
                <AccountCircle />
              )}
            </IconButton>

            {/* <BiSupport /> */}
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {renderSupportMenu}
      {logoutClicked && workspaceDataSaveError && (
        <SnackbarHandler
          severity={"error"}
          message={"Internal Server Error,Please try again"}
        />
      )}
      {getWorkspaceDataError && <SnackbarHandler
          severity={"error"}
          message={"Internal Server Error,Please try again"}
        />}
    </Box>
  );
};

export default Header;
